<ng-container *ngIf="!state.showPopupButtonInsteadOfColumnNames">
  <ng-container *ngIf="state.columns">
    <span class="column-chip p-2 mr-1" *ngFor="let column of state.columns; trackBy: trackByFn">
      <y42-column-type-icon *ngIf="column.columnType" [type]="column.columnType"></y42-column-type-icon>
      {{ column.columnName }}
    </span>
    <span *ngIf="state.showThreeDots" class="column-chip p-2" [matTooltip]="state.threeDotsHoverText">...</span>
  </ng-container>
</ng-container>

<span *ngIf="state.showPopupButtonInsteadOfColumnNames">
  <!-- TODO TECH-7874 make this part reusable and also use in JobDisplayDropdownComponent -->
  <button
    y42StopPropagation
    mat-button
    class="border-common popup-button"
    #matMenuTrigger="matMenuTrigger"
    [matMenuTriggerFor]="menu"
  >
    {{ state.allColumns.length }}X
  </button>

  <mat-menu #menu="matMenu" class="invisible">
    <ng-template matMenuContent>
      <y42-search-dropdown
        [items]="state.allColumns"
        [initiallyOpen]="true"
        [itemTemplate]="itemTemplate"
        placeholder="Search"
        [searchCallback]="columnsSearchCallback"
        (closed)="close()"
      >
      </y42-search-dropdown>
    </ng-template>

    <ng-template #itemTemplate let-item="item">
      <y42-column-type-icon *ngIf="item.columnType" [type]="item.columnType"></y42-column-type-icon>
      {{ item.columnName }}
    </ng-template>
  </mat-menu>
</span>

<span *ngIf="state.expandToSee">(Expand to see)</span>
